import type { ChangelogActionRow, ChangelogItemRow } from '../interfaces'
import type { Pagination } from '@shared/config'
import type { ChangelogStore } from './interfaces'

import { isFullArray } from '@shared/lib/collections'

export const getters = {
  getListSource: (state: ChangelogStore): ChangelogStore['listSource'] => state.listSource,
  isLoading: (state: ChangelogStore): ChangelogStore['loading'] => state.loading,
  getActions: (state: ChangelogStore): ChangelogActionRow[] => state.actions,
  hasActions: (state: ChangelogStore): boolean => isFullArray(state.actions),
  getMeta: (state: ChangelogStore): Pagination | null => state.meta,
  getFilterSearch: (state: ChangelogStore): ChangelogStore['filterSearch'] => state.filterSearch,
  getFilterFrom: (state: ChangelogStore): ChangelogStore['filterFrom'] => state.filterFrom,
  getFilterTo: (state: ChangelogStore): ChangelogStore['filterTo'] => state.filterTo,
  hasFilters: (state: ChangelogStore): boolean =>
    state.filterSearch !== null || state.filterFrom !== null || state.filterTo !== null,
  getPerPage: (state: ChangelogStore): ChangelogStore['perPage'] => state.perPage,
  getCursor: (state: ChangelogStore): ChangelogStore['cursor'] => state.cursor,
  getNextCursor: (state: ChangelogStore): string | null => state.meta?.next_cursor ?? null,
  getPrevCursor: (state: ChangelogStore): string | null => state.meta?.prev_cursor ?? null,
  hasNext: (state: ChangelogStore): boolean => !!state.meta?.next_cursor,
  hasPrev: (state: ChangelogStore): boolean => !!state.meta?.prev_cursor,
  getExpandedActionId: (state: ChangelogStore): ChangelogStore['expandedActionId'] => state.expandedActionId,
  getItems: (state: ChangelogStore): ChangelogItemRow[] => state.items,
  isItemsLoading: (state: ChangelogStore): ChangelogStore['itemsLoading'] => state.itemsLoading,
  getDetailItem: (state: ChangelogStore): ChangelogStore['detailItem'] => state.detailItem,
}
